/**
 * A cor de cada faixa de ocupação, numa tabela só: a grade, a legenda, o medidor "hoje"
 * e a coluna de ocupação do detalhe leem daqui. Uma legenda que nomeia o seu próprio tom
 * em vez do tom do quadrinho é uma legenda que mente assim que um dos dois muda.
 *
 * São os tokens de sucesso, aviso e perigo do tema, e não um laranja próprio deste
 * produto: o farol da OP já usa os três, então a mesma cor quer dizer a mesma coisa nas
 * duas leituras do painel. Cada preenchimento carrega a sua tinta (`-fg`), escolhida por
 * contraste em cada tema, e `tinta` é a versão que lê sobre o fundo da tela.
 */
import type { FaixaDeOcupacao } from '@/domain/configuracao/helpers/faixasOcupacao';

export interface IClassesDaFaixa {
  /** Preenchimento do quadrinho, da barra do medidor e do quadradinho da legenda. */
  fundo: string;
  /** Tinta que lê SOBRE o preenchimento. */
  texto: string;
  /** Tinta do número quando ele fica sobre a tela, sem preenchimento atrás. */
  tinta: string;
}

/**
 * Escritas uma por uma, nunca montadas por interpolação: o Tailwind lê os nomes de
 * classe do texto do arquivo e não veria um nome construído em tempo de execução.
 */
export const CLASSES_DA_FAIXA: Readonly<Record<FaixaDeOcupacao, IClassesDaFaixa>> = {
  // O preenchimento é o verde claro próprio (ver `globals.css`): o da biblioteca é um
  // verde garrafa escuro no tema claro. A TINTA segue sendo a do tema, porque ali o tom
  // escuro é justamente o que lê sobre o fundo claro.
  folga: {
    fundo: 'bg-ocupacao-folga',
    texto: 'text-ocupacao-folga-fg',
    tinta: 'text-success-emphasis',
  },
  // O preenchimento do meio é o laranja próprio (ver `globals.css`): o da biblioteca é
  // um mostarda escuro que chegava na tela como marrom. A TINTA segue sendo a do tema,
  // porque ali o tom escuro é justamente o que lê sobre o fundo claro.
  limite: {
    fundo: 'bg-ocupacao-limite',
    texto: 'text-ocupacao-limite-fg',
    tinta: 'text-warning-emphasis',
  },
  estouro: { fundo: 'bg-danger', texto: 'text-danger-fg', tinta: 'text-danger-emphasis' },
  // Sem carga programada ou sem capacidade: a semana não tem leitura para dar, e pintá-la
  // de verde diria que há folga onde ninguém disse qual é o tamanho da célula.
  vazio: { fundo: 'bg-muted', texto: 'text-foreground-faint', tinta: 'text-foreground-faint' },
};

/** As faixas na ordem em que a legenda as lista, da mais confortável para a pior. */
export const FAIXAS_DA_LEGENDA: ReadonlyArray<FaixaDeOcupacao> = [
  'folga',
  'limite',
  'estouro',
  'vazio',
];
